import { Add } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import ButtonActionsComponent from '../../../components/ButtonActionsComponent';
import ButtonComponent from '../../../components/ButtonComponent';
import TableComponent, {
  IColumnProps,
} from '../../../components/TableComponent';

import ConfirmDeleteModalComponent from '../../../components/ConfirmDeleteModalComponent';
import { ILprDeviceFilterProps } from '../../../services/Devices/LprService/types';
import {
  useDeleteSchoolClassAsync,
  useGetAllSchoolClassByLicenseAsync,
  useGetSchoolClassByIdAsync,
} from '../../../services/SchoolClass/hooks/useMutation';
import {
  ISchoolClassProps,
  ISchoolClassSimpleProps
} from '../../../services/SchoolClass/types';
import { IPaginationParams } from '../../../services/types';
import SchoolClassEditionModal from './SchoolClassEditionModal';

const SchoolClassList = () => {
  const [schoolTransportation, setSchoolTransportation] = useState<
    ISchoolClassSimpleProps[]
  >([]);
  const [isVisibleImageModal, setIsVisibleImageModal] =
    useState<boolean>(false);
  const [imageUrlToRender, setImageUrlToRender] = useState<string>('');
  const [isVisibleEditionModal, setIsVisibleEditionModal] =
    useState<boolean>(false);
  const [selectedItemToDelete, setSelectedItemToDelete] =
    useState<ISchoolClassSimpleProps>();
  const [responsibleToEdit, setResponsibleToEdit] = useState<
    ISchoolClassProps | undefined
  >(undefined);
  const [isVisibleDeleteItemModal, setIsVisibleDeleteItemModal] =
    useState<boolean>(false);
  const [pagination, setPagination] = useState<IPaginationParams>({
    pageNumber: 1,
    pageSize: 10,
  });
  const [filter, setFilter] = useState<ILprDeviceFilterProps>({
    name: '',
  });
  const { mutateAsync, reset } = useGetAllSchoolClassByLicenseAsync();
  const { mutateAsync: mutateResponsibleAsync } = useGetSchoolClassByIdAsync();
  const {
    mutateAsync: mutateDeleteResponsibleAsync,
    isLoading: isLoadingDeleteResponsible,
  } = useDeleteSchoolClassAsync();
  const handleOpenImageModal = (imageUrl: string) => {
    setIsVisibleImageModal(true);
    setImageUrlToRender(imageUrl);
  };

  const columns: IColumnProps[] = [
    {
      id: 'name',
      label: 'Nome',
      width: '40%',
    },
    {
      id: 'id',
      label: 'Ações',
      align: 'center',
      width: 'min',
      render: (id) => (
        <ButtonActionsComponent
          key={id}
          isWithDefaultOptionsList
          handleDelete={() => handleDeleteItem(Number(id))}
          handleEdit={() => handleEdit(Number(id))}
        />
      ),
    },
  ];

  useEffect(() => {
    mutateAsync().then(setSchoolTransportation);
  }, []);
  const handleDeleteItem = async (id: number) => {
    const responsible: any = await mutateResponsibleAsync(id);
    setSelectedItemToDelete(responsible);
    setIsVisibleDeleteItemModal(true);
  };

  const handleEdit = (id: number) => {
    mutateResponsibleAsync(id).then(setResponsibleToEdit);
    setIsVisibleEditionModal(true);
  };
  const refetchResponsible = () => {
    mutateAsync().then(setSchoolTransportation);
  };
  const handleConfirmDeletion = () => {
    if (selectedItemToDelete?.id)
      mutateDeleteResponsibleAsync(selectedItemToDelete?.id).then(() => {
        setPagination((oldStt) => ({ ...oldStt, pageNumber: 1 }));
        setIsVisibleDeleteItemModal(false);
        refetchResponsible();
      });
  };
  const handleCancelDeletion = () => {
    setIsVisibleDeleteItemModal(false);
    setSelectedItemToDelete(undefined);
  };
  return (
    <>
      <TableComponent
        title="Turmas"
        additionalTitleComponent={
          <ButtonComponent
            onClick={() => setIsVisibleEditionModal(true)}
            startIcon={<Add />}
          >
            Nova Turma
          </ButtonComponent>
        }
        rows={schoolTransportation}
        columns={columns}
      />
      <ConfirmDeleteModalComponent
        isLoading={isLoadingDeleteResponsible}
        isVisibleDeleteDialog={isVisibleDeleteItemModal}
        setIsVisibleDeleteDialog={setIsVisibleDeleteItemModal}
        title={'Excluir Turma'}
        message={`Tem certeza que deseja excluir esta Turma "${selectedItemToDelete?.id}"?`}
        handleCancelDeletion={handleCancelDeletion}
        handleConfirmDeletion={handleConfirmDeletion}
      />
      <SchoolClassEditionModal
        handleSaveForm={() => mutateAsync().then(setSchoolTransportation)}
        responsibleEdit={responsibleToEdit}
        isOpen={isVisibleEditionModal}
        setIsOpen={setIsVisibleEditionModal}
      />
    </>
  );
};

export default SchoolClassList;
